import React from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import {
  hasVerifiedPhoneSelector,
  hasUnverifiedPhoneSelector,
} from '../../../../../shared/app/bundles/user/index.js'
import SettingsEditField from '../settings-edit-field/index.jsx'
import SectionHeading from '../section-heading/index.jsx'
import { messages } from '../messages.js'
import sectionMessages from './messages.js'

const SecuritySection = ({ hasVerifiedPhone, hasUnverifiedPhone }) => {
  const labelButtonMessage = !hasVerifiedPhone ? sectionMessages.turnOn : null
  const destinationPath =
    hasVerifiedPhone || hasUnverifiedPhone ? '/mfa' : '/mfa/add-phone-number'

  return (
    <React.Fragment>
      <SectionHeading {...sectionMessages.securityHeading} />
      <div className="py1" data-e2e="security">
        <SettingsEditField
          label={<FormattedMessage {...messages.mfa} />}
          labelButton={labelButtonMessage}
          path={`/account/settings${destinationPath}`}
        />
      </div>
    </React.Fragment>
  )
}

const select = (state) => ({
  hasUnverifiedPhone: hasUnverifiedPhoneSelector(state),
  hasVerifiedPhone: hasVerifiedPhoneSelector(state),
})

export default connect(select)(SecuritySection)
